import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // Importa App como valor predeterminado
import './index.css';

createRoot(document.getElementById('root')).render(<App />);
